<section>
  <div class="w-full py-3 flex align-items-center justify-content-between border-bottom-1 border-bottom-solid mb-3"
    [style]="{ 'border-color': 'var(--primary-gray)' }">
    <h2 class="text-xl font-semibold" data-clarity-unmask="true">Dodaj kursanta</h2>
    <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" [disabled]="loading"
      (onClick)="closeDialog()" data-clarity-unmask="true"></p-button>
  </div>
</section>
<section>
  <p-stepper [linear]="true" [(activeStep)]="activeStep">
    <!-- The account is created for the e-mail, so the school first learns whether the student already has one. -->
    <p-stepperPanel header="E-mail kursanta">
      <ng-template pTemplate="header" let-index="index">
        <div class="flex justify-content-center gap-2 align-items-center">
          <button class="bg-transparent border-none flex-column gap-2 justify-content-center align-items-center" data-clarity-unmask="true">
            <div class="round-indicator" style="background-color: #334155">
              1
            </div>
          </button>
          <div class="text-color-secondary">E-mail kursanta</div>
        </div>
      </ng-template>
      <ng-template pTemplate="content" let-nextCallback="nextCallback">
        <div class="student-lookup">
          <label for="studentEmail" class="block text-gray-500 font-normal text-sm mb-2">Adres e-mail kursanta</label>
          <div class="student-lookup__search">
            <input id="studentEmail" type="email" pInputText pAutoFocus [autofocus]="true" [formControl]="emailControl"
              placeholder="np. jan.kowalski@gmail.com" autocomplete="off" aria-describedby="studentLookupResult"
              [class.ng-dirty]="lookupState === 'invalid'" [class.ng-invalid]="lookupState === 'invalid'"
              (keydown.enter)="searchStudent()" />
            <p-button label="Szukaj kursanta" icon="pi pi-search" [loading]="lookupState === 'checking'"
              (onClick)="searchStudent()" data-clarity-unmask="true" />
          </div>
          <div id="studentLookupResult" class="student-lookup__result" aria-live="polite" [ngSwitch]="lookupState">
            <small *ngSwitchCase="'idle'" class="text-gray-500">
              Konto kursanta zakładamy na adres e-mail - po jego wpisaniu sprawdzimy, czy kursant już je ma.
            </small>
            <small *ngSwitchCase="'invalid'" class="error-message">
              To nie jest poprawny adres e-mail - sprawdź, czy ma znak &#64; i domenę, np. jan.kowalski&#64;gmail.com.
            </small>
            <small *ngSwitchCase="'checking'" class="text-gray-500">
              <i class="pi pi-spin pi-spinner text-xs mr-1"></i>Sprawdzam, czy kursant ma konto...
            </small>
            <div *ngSwitchCase="'new'" class="lookup-note lookup-note--new">
              <i class="pi pi-user-plus"></i>
              <div>
                <strong>Brak konta na ten adres.</strong> Przejdź dalej i uzupełnij dane kursanta - założymy mu konto
                i wyślemy link aktywacyjny.
              </div>
            </div>
            <div *ngSwitchCase="'invite'" class="lookup-note lookup-note--found">
              <i class="pi pi-user"></i>
              <div>
                <strong>Kursant ma już konto</strong> (bez aktywnego dostępu). Wyślemy mu zaproszenie - dołączy do
                Twojego OSK, gdy je zaakceptuje (ma na to 14 dni). Do tego czasu nie zobaczysz jego danych. Przejdź
                dalej, aby wybrać abonament, grupę i prowadzącego.
              </div>
            </div>
            <div *ngSwitchCase="'inviteActive'" class="lookup-note lookup-note--found">
              <i class="pi pi-user"></i>
              <div>
                <strong>Kursant ma już konto</strong> z aktywnym dostępem. Wyślij mu zaproszenie - dołączy do Twojego
                OSK, gdy je zaakceptuje (ma na to 14 dni). Do tego czasu nie zobaczysz jego danych.
              </div>
            </div>
            <div *ngSwitchCase="'member'" class="lookup-note lookup-note--found">
              <i class="pi pi-check-circle"></i>
              <div>
                <strong>Kursant jest już w Twoim ośrodku</strong> (np. aktywował dostęp z Twojej książki). Przejdź
                dalej, aby przydzielić mu abonament, grupę lub prowadzącego - bez zaproszenia.
              </div>
            </div>
            <div *ngSwitchCase="'memberActive'" class="lookup-note lookup-note--found">
              <i class="pi pi-check-circle"></i>
              <div>
                <strong>Kursant jest już w Twoim ośrodku</strong> i ma aktywny dostęp. Znajdziesz go na liście kursantów.
              </div>
            </div>
            <div *ngSwitchCase="'pending'" class="lookup-note lookup-note--new">
              <i class="pi pi-clock"></i>
              <div>
                <strong>Zaproszenie już czeka na odpowiedź kursanta</strong> (ważne do {{ pendingInvitationExpires }}).
                Możesz je wysłać ponownie albo wycofać w zakładce „Zaproszeni”.
              </div>
            </div>
            <small *ngSwitchCase="'notStudent'" class="error-message">
              Tego konta nie można dodać jako kursanta.
            </small>
            <small *ngSwitchCase="'throttled'" class="error-message">
              Za dużo sprawdzeń adresów w krótkim czasie. Spróbuj ponownie za kilka minut.
            </small>
            <small *ngSwitchCase="'error'" class="error-message">
              Nie udało się sprawdzić adresu. Kliknij „Szukaj kursanta”, aby spróbować ponownie.
            </small>
          </div>
        </div>
        <div class="step-actions flex pt-4 justify-content-end gap-3">
          <p-button label="Anuluj" [outlined]="true" (onClick)="closeDialog()" [disabled]="loading" data-clarity-unmask="true">
          </p-button>
          <p-button *ngIf="lookupState === 'inviteActive'; else toStudentData" label="Wyślij zaproszenie" icon="pi pi-send"
            [loading]="loading" (onClick)="inviteStudentWithAccess()" data-clarity-unmask="true" />
          <ng-template #toStudentData>
            <p-button label="Dalej" icon="pi pi-arrow-right" iconPos="right" [disabled]="!canEnterStudentData"
              (onClick)="goToStudentData(nextCallback)" data-clarity-unmask="true" />
          </ng-template>
        </div>
      </ng-template>
    </p-stepperPanel>

    <p-stepperPanel header="Dane kursanta">
      <ng-template pTemplate="header" let-index="index">
        <div class="flex justify-content-center gap-2 align-items-center">
          <button class="bg-transparent border-none flex-column gap-2 justify-content-center align-items-center" data-clarity-unmask="true">
            <div class="round-indicator" [ngStyle]="{
                backgroundColor: activeStep >= 1 ? '#334155' : '#E2E8F0'
              }">
              2
            </div>
          </button>
          <div class="text-color-secondary">Dane kursanta</div>
        </div>
      </ng-template>
      <ng-template pTemplate="content" let-nextCallback="nextCallback" let-prevCallback="prevCallback">
        <form [formGroup]="dynamicForm">
          <div *ngIf="accountExists" class="lookup-note lookup-note--found mb-2">
            <i class="pi pi-info-circle"></i>
            <div *ngIf="sendsInvitation; else memberDataNote">
              Kursant ma już konto - imię, nazwisko, telefon, PKK i PESEL wpisane tutaj nie zmienią danych na jego koncie
              (trafią tylko do pobieranych dokumentów). Kategoria, grupa, prowadzący i adres zapiszą się, gdy kursant
              przyjmie zaproszenie.
            </div>
            <ng-template #memberDataNote>
              <div>
                Kursant ma już konto - imię, nazwisko, telefon, PKK i PESEL wpisane tutaj nie zmienią danych na jego
                koncie (trafią tylko do pobieranych dokumentów). Dane konta poprawisz w szczegółach kursanta.
              </div>
            </ng-template>
          </div>
          <div class="flex flex-wrap justify-content-between">
            <ng-container *ngFor="let field of formFields">
              <div [ngSwitch]="field.type"
                class="w-full lg:w-26rem flex-wrap sm:flex-nowrap flex border-bottom-1 border-bluegray-300"
                [style]="{ 'padding-block': '12px' }">
                <label [for]="field.name"
                  class="flex-none flex flex-column justify-content-center w-11rem text-gray-500 font-normal text-sm">
                  {{ field.label }}
                  <small *ngIf="field.hint" class="text-xs text-gray-400">{{ field.hint }}</small>
                </label>
                <div class="w-full min-w-0">
                  <input *ngSwitchDefault [id]="field.name" type="text" pInputText [formControlName]="field.name"
                    (blur)="trimInput(field.name)" />
                  <p-inputNumber *ngSwitchCase="'input-number'" class="w-full" styleClass="w-full" [id]="field.name"
                    inputId="integeronly" [formControlName]="field.name" />
                  <p-inputMask *ngSwitchCase="'input-mask'" class="w-full" styleClass="w-full"
                    [mask]="field.mask ? field.mask : '(999) 999-9999'" [formControlName]="field.name"/>
                  <p-dropdown *ngSwitchCase="'dropdown'" class="w-full" styleClass="w-full" [inputId]="field.name"
                    [options]="examCategoryOptions" [formControlName]="field.name" [placeholder]="field.placeholder ?? ''"
                    appendTo="body" />
                  <p-dropdown *ngSwitchCase="'teacher'" class="w-full" styleClass="w-full" [inputId]="field.name"
                    [options]="teacherOptions" [formControlName]="field.name" [placeholder]="field.placeholder ?? ''"
                    [showClear]="true" emptyMessage="Brak instruktorów i wykładowców - dodasz ich w zakładce Pracownicy"
                    appendTo="body" />
                  <ng-container *ngSwitchCase="'lecture-group'">
                    <p-dropdown *ngIf="!creatingLectureGroup" #lectureGroupDropdown class="w-full" styleClass="w-full"
                      [inputId]="field.name" [options]="lectureGroupOptions" [formControlName]="field.name"
                      [placeholder]="field.placeholder ?? ''" [showClear]="true" emptyMessage="Brak otwartych grup"
                      appendTo="body">
                      <ng-template pTemplate="footer">
                        <div class="p-2 border-top-1 surface-border">
                          <p-button label="Nowa grupa" icon="pi pi-plus" [text]="true" size="small"
                            styleClass="w-full justify-content-start"
                            (onClick)="lectureGroupDropdown.hide(); startLectureGroupCreation()" data-clarity-unmask="true" />
                        </div>
                      </ng-template>
                    </p-dropdown>
                    <ng-container *ngIf="creatingLectureGroup">
                      <div class="new-lecture-group">
                        <input type="text" pInputText pAutoFocus [autofocus]="true" [formControl]="newLectureGroupName"
                          placeholder="Nazwa nowej grupy" maxlength="200" aria-label="Nazwa nowej grupy"
                          (keydown.enter)="$event.preventDefault(); createLectureGroup()" />
                        <p-button icon="pi pi-check" pTooltip="Utwórz grupę" tooltipPosition="top"
                          ariaLabel="Utwórz grupę" [loading]="savingLectureGroup" (onClick)="createLectureGroup()" data-clarity-unmask="true" />
                        <p-button icon="pi pi-times" [outlined]="true" pTooltip="Anuluj" tooltipPosition="top"
                          ariaLabel="Anuluj tworzenie grupy" [disabled]="savingLectureGroup"
                          (onClick)="cancelLectureGroupCreation()" data-clarity-unmask="true" />
                      </div>
                      <small *ngIf="newLectureGroupCategory as category" class="text-xs text-gray-400">
                        Nowa grupa dla kategorii {{ category }}
                      </small>
                      <small *ngIf="newLectureGroupError" class="error-message block">{{ newLectureGroupError }}</small>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </ng-container>

          </div>
          <div class="step-actions flex pt-4 justify-content-between gap-3">
            <p-button label="Wstecz" [outlined]="true" [disabled]="loading" icon="pi pi-arrow-left"
              (onClick)="prevCallback.emit()" data-clarity-unmask="true"></p-button>
            <div class="flex gap-3">
              <p-button label="Anuluj" [outlined]="true" (onClick)="closeDialog()" [disabled]="loading" data-clarity-unmask="true">
              </p-button>
              <p-button label="Dalej" icon="pi pi-arrow-right" iconPos="right" [disabled]="loading"
                (onClick)="goToSubscriptions(nextCallback)" data-clarity-unmask="true" />
            </div>
          </div>
        </form>
      </ng-template>
    </p-stepperPanel>

    <p-stepperPanel header="Abonamenty">
      <ng-template pTemplate="header" let-index="index">
        <div class="flex justify-content-center gap-2 align-items-center">
          <button class="bg-transparent border-none flex-column gap-2 justify-content-center align-items-center" data-clarity-unmask="true">
            <div class="round-indicator" [ngStyle]="{
                backgroundColor: activeStep >= 2 ? '#334155' : '#E2E8F0'
              }">
              3
            </div>
          </button>
          <div class="text-color-secondary">Abonament (opcjonalnie)</div>
        </div>
      </ng-template>
      <ng-template pTemplate="content" let-nextCallback="nextCallback" let-prevCallback="prevCallback"
        let-index="index">
        <div *ngIf="sendsInvitation" class="lookup-note lookup-note--new mt-3">
          <i class="pi pi-info-circle"></i>
          <div>
            Wybrany abonament zarezerwujemy dla kursanta. Wróci do puli, jeśli kursant odrzuci zaproszenie, nie
            odpowie w ciągu 14 dni albo je wycofasz.
          </div>
        </div>
        <app-subscription-selector
          [(missingSubscriptionMessage)]="missingSubscriptionMessage"
          [(selectedSubscription)]="selectedSubscription"></app-subscription-selector>
        <div class="step-actions flex pt-4 justify-content-between gap-3">
          <p-button label="Wstecz" [outlined]="true" [disabled]="loading" icon="pi pi-arrow-left"
            (onClick)="prevCallback.emit()" data-clarity-unmask="true"></p-button>
          <div class="flex gap-3">
            <p-button label="Anuluj" [outlined]="true" (onClick)="closeDialog()" [disabled]="loading" data-clarity-unmask="true">
            </p-button>
            <p-button label="Dalej" icon="pi pi-arrow-right" iconPos="right" [disabled]="loading"
              (onClick)="goToDocuments(nextCallback)" data-clarity-unmask="true" />
          </div>
        </div>
      </ng-template>
    </p-stepperPanel>
    <p-stepperPanel header="Dokumenty">
      <ng-template pTemplate="header" let-index="index">
        <div class="flex justify-content-center gap-2 align-items-center">
          <button class="bg-transparent border-none flex-column gap-2 justify-content-center align-items-center" data-clarity-unmask="true">
            <div class="round-indicator" [ngStyle]="{
                backgroundColor: activeStep === 3 ? '#334155' : '#E2E8F0'
              }">
              4
            </div>
          </button>
          <div class="text-color-secondary">Dokumenty</div>
        </div>
      </ng-template>
      <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index">
        <div class="documents-step">
          <div class="mb-4">
            <h3 class="text-lg font-semibold mb-2">Dokumenty kursanta</h3>
            <p *ngIf="!sendsInvitation; else invitationDocumentsNote" class="text-gray-500 line-height-3 m-0">
              Przed utworzeniem użytkownika możesz pobrać dokumenty uzupełnione bieżącą datą i danymi kursanta.
              Pozostałe pola można dopisać po wydrukowaniu. Wybrana umowa zostanie zapisana przy kursancie, gdy go
              utworzysz - pobierzesz ją też później z jego szczegółów.
            </p>
            <ng-template #invitationDocumentsNote>
              <p class="text-gray-500 line-height-3 m-0">
                Możesz pobrać i wydrukować dokumenty uzupełnione bieżącą datą i danymi z formularza. Umowę zapiszesz
                przy kursancie w jego szczegółach (zakładka „Umowy”), gdy przyjmie zaproszenie.
              </p>
            </ng-template>
          </div>

          <div class="documents-grid">
            <div class="document-card document-card--agreement">
              <i class="pi pi-file-edit document-card__icon"></i>
              <div class="flex-1 min-w-0">
                <h4 class="font-semibold mb-1">Umowa szkoły</h4>
                <p class="text-sm text-gray-500 mb-2">
                  Wybierz kurs i umowę - dane kursanta, szkoły i kursu (cena, raty) wypełnią się same.
                </p>
                <app-agreement-picker
                  #agreementPicker
                  [examCategoryGuid]="fc['examCategoryGuid'].value"
                  [initialSelection]="agreementSelection"
                  (selectionChange)="agreementSelection = $event"
                ></app-agreement-picker>
              </div>
              <p-button *ngIf="agreementPicker.hasAgreements" label="Pobierz" icon="pi pi-download" [outlined]="true"
                [loading]="documentLoading === 'oskAgreement'"
                [disabled]="documentLoading !== null || !agreementSelection.agreementGuid"
                (onClick)="downloadChosenAgreement()" data-clarity-unmask="true"></p-button>
            </div>

            <!-- The platform's fixed agreement, for schools that have not prepared their own yet. -->
            <div class="document-card" *ngIf="agreementPicker.loaded && !agreementPicker.hasAgreements">
              <i class="pi pi-file-pdf document-card__icon"></i>
              <div class="flex-1">
                <h4 class="font-semibold mb-1">Umowa i regulamin</h4>
                <p class="text-sm text-gray-500 m-0">Imię i nazwisko, PESEL, PKK, adres, telefon oraz data</p>
              </div>
              <p-button label="Pobierz" icon="pi pi-download" [outlined]="true"
                [loading]="documentLoading === 'agreement'" [disabled]="documentLoading !== null"
                (onClick)="downloadAgreement()" data-clarity-unmask="true"></p-button>
            </div>

            <div class="document-card">
              <i class="pi pi-shield document-card__icon"></i>
              <div class="flex-1">
                <h4 class="font-semibold mb-1">Zgoda RODO</h4>
                <p class="text-sm text-gray-500 m-0">Imię i nazwisko oraz data na obu kopiach</p>
              </div>
              <p-button label="Pobierz" icon="pi pi-download" [outlined]="true"
                [loading]="documentLoading === 'rodo'" [disabled]="documentLoading !== null"
                (onClick)="downloadRodo()" data-clarity-unmask="true"></p-button>
            </div>
          </div>

          <div class="step-actions flex pt-4 justify-content-between gap-3">
            <p-button label="Wstecz" icon="pi pi-arrow-left" [outlined]="true" [disabled]="loading"
              (onClick)="prevCallback.emit()" data-clarity-unmask="true"></p-button>
            <div class="flex gap-3">
              <p-button label="Anuluj" [outlined]="true" [disabled]="loading"
                (onClick)="closeDialog()" data-clarity-unmask="true"></p-button>
              <p-button
                [label]="sendsInvitation ? 'Wyślij zaproszenie' : accountExists ? 'Zapisz' : 'Utwórz użytkownika'"
                [icon]="sendsInvitation ? 'pi pi-send' : accountExists ? 'pi pi-check' : 'pi pi-user-plus'" [loading]="loading"
                (onClick)="sendInvitation()" data-clarity-unmask="true"></p-button>
            </div>
          </div>
        </div>
      </ng-template>
    </p-stepperPanel>
  </p-stepper>
</section>
